import classNames from "classnames/bind";
import styles from "./ConfigVariable.module.css";
import { useEffect, useState } from "react";
import { aiConfigFRS } from "../../../../../../services/api/aiConfigFRS";
import { Alert, Button, Loading, Toast } from "../../../../../../components";
import { schedules } from "../../ConfigVariable/ConfigSchedule";
import { useTranslation } from "react-i18next";
import FormInfo from "../../../../../../components/FormInfo";
import { formItem } from "./config";
import { useForm } from "antd/es/form/Form";
import { configFrsUniview } from "../../../../../../services/api/configFrsUniview";
import { aiConfigService } from "../../../../../../services/api/aiConfigService";

const cx = classNames.bind(styles);
function ConfigVariable({ cameraCode, ...props }) {
    const { onClose, statusAi, isChanged, setIsChanged } = props;
    const [reFresh, setReFresh] = useState(false);
    const [loading, setLoading] = useState(true);
    const [formDataConfig] = useForm();
    const { t } = useTranslation();
    const [config, setConfig] = useState();
    const [timeKeepingEventMax, setTimeKeepingEventMax] = useState(1);
    const [listSchedule, setListSchedule] = useState([]);


    const getInitInfoUniCam = async () => {
        try {
            const param = {
                camera_code: cameraCode
            }
            const res = await configFrsUniview.get(param);
            setConfig(res);
            formDataConfig.setFieldValue('sensitive', res?.Polygons[0]?.Sensitivity);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }

    // lấy danh sách các chức năng thoogn báo cho ai
    const getListLableSchedule = (timeClean) => {
        const schedulesAddValue = schedules.map(item => {
            switch (item?.param) {
                case 'TIME_KEEPING_EVENT':
                    // timeClean?.TIME_KEEPING
                    return {
                        ...item,
                        type: 'inputNumber',
                        name: item?.param?.toLocaleLowerCase(),
                        span: 24,
                        bordered: false,
                        min: 1,
                        max: timeClean?.TIME_KEEPING_DEFAULT,
                        step: 1,
                        align: 'right'
                    }
                default:
                    return {
                        hide: true
                    }
            }
        })
        setListSchedule(schedulesAddValue);
    }

    const getListSchedule = async () => {
        try {
            const timeClean = await aiConfigService.getDefaultConfig(cameraCode);
            setTimeKeepingEventMax(timeClean?.TIME_KEEPING_DEFAULT || 1);
            getListLableSchedule(timeClean);
            formDataConfig.setFieldValue('time_keeping_event', timeClean?.TIME_KEEPING || 1);
        } catch (error) {
            throw error;
        }
    }

    useEffect(() => {
        getListSchedule()
        getInitInfoUniCam()
    }, [cameraCode, reFresh])

    const handleCancel = () => {
        setLoading(true)
        setReFresh(!reFresh)
        if (onClose) {
            onClose();
        }
    }

    const handleTurnOn = async () => {
        setLoading(true)
        try {
            const polygons = config?.Polygons?.map(polygon => {
                return {
                    ...polygon,
                    Sensitivity: formDataConfig.getFieldValue('sensitive')
                }
            })
            const dataConfig = {
                ...config,
                Polygons: polygons
            }
            const param = {
                camera_code: cameraCode
            }
            const configSchedule = {
                ai_param_level_code: {
                    code: [29, 30]
                },
                ai_service_code: "20230222000000000002",
                camera_code: cameraCode,
            }
            const cleanEvent = {
                cameraid: cameraCode,
                time_keeping: formDataConfig.getFieldValue('time_keeping_event')?.toString()
            }
            await aiConfigFRS.postAddAiConfig(configSchedule)
            await configFrsUniview.put(param, dataConfig)
            await aiConfigService.configAi(cleanEvent)
            if (isChanged) {
                Toast.open("Bật Nhận dạng khuôn mặt thành công", 'success')
            } else {
                Toast.open("Cài đặt Nhận dạng khuôn mặt thành công", 'success')
            }
            setLoading(false)
            setIsChanged(false)
        } catch (error) {
            if (isChanged) {
                if (error?.response?.data?.message && error?.response?.data?.message?.search("403") >= 0) {
                    Toast.open("Không có quyền bật Nhận dạng khuôn mặt", 'danger')
                } else {
                    Toast.open("Bật Nhận dạng khuôn mặt không thành công", 'danger')
                }
            } else {
                Toast.open("Cài đặt Nhận dạng khuôn mặt không thành công", 'danger')
            }
            setLoading(false)
        }
    }

    const handleTurnOff = async () => {
        setLoading(true)
        try {
            const param = {
                camera_code: cameraCode,
                ai_service_code: "20230222000000000002"
            }
            await aiConfigFRS.deleteConfig(param)
            Toast.open("Tắt Nhận dạng khuôn mặt thành công", 'success')
            setLoading(false)
            setIsChanged(false)
        } catch (error) {
            setLoading(false)
            if (isChanged) {
                if (error?.response?.data?.message && error?.response?.data?.message?.search("403") >= 0) {
                    Toast.open("Không có quyền tắt Nhận dạng khuôn mặt", 'danger')
                } else {
                    Toast.open("Tắt Nhận dạng khuôn mặt không thành công", 'danger')
                }
            } else {
                Toast.open("Cài đặt Nhận dạng khuôn mặt không thành công", 'danger')
            }
        }
    }

    const handleAccept = async () => {
        if (statusAi) {
            handleTurnOn()
        } else {
            handleTurnOff()
        }

    }

    const direactionProps = {
        size: 'large',
        align: 'center',
        className: cx("space")
    }

    const formItemProps = {
        noStyle: true
    }

    return (
        <>
            <FormInfo
                listInfo={[...listSchedule, ...formItem]}
                form={formDataConfig}
                direction={"horizontal"}
                directionProps={direactionProps}
                formItemProps={formItemProps}
            />
            <div className={cx('footer')}>
                <Button
                    title={t('stream.cancelCustom')}
                    className={cx("btn-cancle")}
                    onClick={handleCancel}
                />
                <Button
                    title={t('settingCam.Save_settings')}
                    className={cx("btn-save")}
                    onClick={handleAccept}
                />
            </div>
            {loading && <div className={cx('modal_loading')}><Loading /></div>}
        </>
    )
}

export default ConfigVariable;